import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/pickList.vue'
createPage(Page)